import styles from './toast-text.module.scss';

const ToastText = () => (
  <p className={styles.toastText}>Your password has been changed</p>
);

export { ToastText };
